
/*
 * The table template every list screen shares (the provider console's Devices card, owner
 * 2026-10-11): a header row with the title at the start and the search and actions at the end,
 * an optional filter row (FilterButtons, counts, bulk actions), notices, then the DataTable.
 * Phones stack the header; the search takes the full width there.
 */
type TableCardProps = {
    className?: string;
    /** The card title, or a node standing in for it (a source picker). */
    title: React.ReactNode;
    /** One line under the title, as Card's: no gap, quiet. */
    description?: React.ReactNode;
    /** Status or count tags: under the title, or under its description when there is one (owner 2026-10-11). */
    tags?: React.ReactNode;
    /** Search and buttons at the end of the header row. */
    actions?: React.ReactNode;
    /** The row under the header: filter buttons at the start, counts and bulk actions at the end. */
    filters?: React.ReactNode;
    /** Notices or a loading line between the controls and the table. */
    notices?: React.ReactNode;
    /** The DataTable, and anything under it (paging, Load more). */
    children: React.ReactNode;
};

const TableCard = ({ className, title, description, tags, actions, filters, notices, children }: TableCardProps) => {
    return (
    // Every box (search, buttons, filters, notices, the table frame) sits flush on the card's 20px padding,
    // 12px apart; the title and its tags sit on that same edge, in line with field labels and the table frame.
    <div className={`card motion-reveal ${className || ""}`}>
        <div className="flex flex-wrap items-center gap-3 min-h-12">
            <div className="py-3 ps-card-inset me-auto min-w-0 max-md:w-full max-md:pe-card-inset">
                <div className="text-card-title">{title}</div>
                {description ? <div className="text-body-2 text-t-secondary">{description}</div> : null}
                {tags ? <div className="flex flex-wrap items-center gap-2 mt-2">{tags}</div> : null}
            </div>
            {actions ? <div className="flex flex-wrap items-center gap-3 max-md:w-full max-md:[&>*]:flex-1">{actions}</div> : null}
        </div>
        {filters ? <div className="flex flex-wrap items-center gap-3 pt-3">{filters}</div> : null}
        {notices ? <div className="flex flex-col gap-3 pt-3 empty:hidden">{notices}</div> : null}
        <div className="pt-3">{children}</div>
    </div>
    );
};

export default TableCard;
